import { render } from "./VentaGanancias.vue?vue&type=template&id=530c675e&scoped=true"
import script from "./VentaGanancias.vue?vue&type=script&lang=js"
export * from "./VentaGanancias.vue?vue&type=script&lang=js"

import "./VentaGanancias.vue?vue&type=style&index=0&id=530c675e&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\framacion_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-530c675e"]])

export default __exports__